import { Component, Input } from '@angular/core'
import { HighlightDirective } from '@shared/directives/higlight.directive'

@Component({
	selector: 'app-profit-triangle',
	templateUrl: './profit-triangle.component.html',
	styleUrl: './profit-triangle.component.scss',
	imports: [HighlightDirective],
})
export class ProfitTriangleComponent {
	@Input() value: number = 0
	@Input() triangleWidth: string = '10px'
	@Input() triangleHeight: string = '10px'
}
